import React, {Component} from 'react';
import './ProfileSidePane.css';
import {Avatar, SocialList, PrimaryButton} from '../widgets';
import {Link} from 'react-router-dom';
import {connect} from 'react-redux';
import {sessionActions} from '../user';
import actions from './profile.actions';
import {uiActions} from '../chrome';
import ProfileHelpPanel from './ProfileHelpPanel';
import {
	getShareProfileLinkedin,
	getShareProfileFacebook,
	getProfileLink,
	copyProfileLink
} from './sharing.util';
import PrimaryLink from '../widgets/PrimaryLink';
import BioHelper from './BioHelper';
import FancyButton from '../widgets/FancyButton';
import Icon from '../widgets/Icon';
import {sessionUserIsIdentifiable} from '../user/session.selectors';
import editingProfileActions from './editingProfile.actions';
import communityActions from '../community/community.actions';

/**
 * Action panel available at the side (bottom on mobile) of the profile
 */
export class ProfileSidePane extends Component {
	componentWillUnmount() {
		if (this.props.clearFirstTime) {
			this.props.clearFirstTime();
		}
	}

	render() {
		if (!this.props.profile) return null;

		const {
			profile: {
				uuid,
				user: {firstname, lastname, location, contacts, uuid: userUuid},
				profile: {profileComplete, uniqueName, brief},
				communities = [],
				avgCommunication,
				avgQuality,
				avgAffordability,
				avgTrust,
				subscriptionLevel,
				contactVisible
			},
			editDetails,
			editContacts,
			editable,
			isViewingOwn,
			isLoggedIn,
			login,
			favourites,
			setFavourite,
			showInvite,
			isAdmin,
			sessionUserIsIdentifiable,
			profileFirstTime,
			newCommunity,
			showCommunityPicker,
			isPromotionPage = false
		} = this.props;

		const isProvider = subscriptionLevel !== 'none';
		const isFavourite = !!(favourites && favourites[uuid]);

		return (
			<section className="ProfileSidePane">
				{isPromotionPage && (
					<PrimaryButton onClick={() => this.props.createPromotion()} icon="note_add">
						Create Promotion
					</PrimaryButton>
				)}

				{!isPromotionPage && isViewingOwn && (
					<PrimaryButton onClick={showInvite} icon="insert_invitation">
						Invite someone to B2Me
					</PrimaryButton>
				)}
				{!isPromotionPage && isViewingOwn && (
					<BioHelper stepKey="invite" center={true} subscriptionLevel={subscriptionLevel} />
				)}

				{!isPromotionPage &&
					isLoggedIn &&
					(isProvider || isAdmin) &&
					!isViewingOwn &&
					sessionUserIsIdentifiable && (
						<PrimaryLink to={`/chats/${userUuid}`} icon="message">
							Message {firstname}
						</PrimaryLink>
					)}
				{!isPromotionPage &&
					isLoggedIn &&
					isProvider &&
					!isViewingOwn &&
					!isFavourite &&
					sessionUserIsIdentifiable && (
						<PrimaryButton onClick={setFavourite} icon="favorite_border">
							Add {firstname} to "My providers"
						</PrimaryButton>
					)}
				{!isPromotionPage &&
					isLoggedIn &&
					isProvider &&
					!isViewingOwn &&
					!sessionUserIsIdentifiable && (
						<div className="ProfileSidePane-collected">
							<Icon name="warning" />
							<span>Complete your profile details to add and enable chat with {firstname}</span>
						</div>
					)}
				{!isPromotionPage &&
					isLoggedIn &&
					isProvider &&
					!isViewingOwn &&
					isFavourite &&
					sessionUserIsIdentifiable && (
						<div className="ProfileSidePane-collected">
							<span className="icon icon-favorite" />
							<span>{firstname} is in "My providers"</span>
						</div>
					)}
				{!isPromotionPage && isLoggedIn && (
					<FancyButton onClick={() => this.props.copyProfile(uniqueName)}>
						<Icon name="share" />
						Share Profile
					</FancyButton>
				)}
				{!isPromotionPage && isLoggedIn && (
					<FancyButton onClick={getShareProfileFacebook(uniqueName)}>
						<Icon name="facebook2" />
						Share on Facebook
					</FancyButton>
				)}
				{!isPromotionPage && isLoggedIn && (
					<FancyButton onClick={getShareProfileLinkedin(uniqueName, firstname, lastname, brief)}>
						<Icon name="linkedin" />
						Share on LinkedIn
					</FancyButton>
				)}

				{!isPromotionPage && isViewingOwn && profileFirstTime && subscriptionLevel !== 'none' && (
					<ProfileHelpPanel profile={this.props.profile} />
				)}

				{!isPromotionPage && isViewingOwn ? (
					<FancyButton onClick={showCommunityPicker}>
						<span className="icon icon-people" />
						<span>Join a community</span>
					</FancyButton>
				) : (
					undefined
				)}

				{!isPromotionPage && isViewingOwn ? (
					<FancyButton onClick={newCommunity}>
						<span className="icon icon-people_outline" />
						<span>Create a community</span>
					</FancyButton>
				) : (
					undefined
				)}

				{!isPromotionPage && editable ? (
					<FancyButton onClick={editDetails}>
						<span className="icon icon-mode_edit" />
						<span>Edit profile details</span>
						{isViewingOwn ? (
							<BioHelper stepKey="basic" subscriptionLevel={subscriptionLevel} />
						) : (
							undefined
						)}
						{isViewingOwn && subscriptionLevel !== 'none' ? (
							<BioHelper stepKey="brief" />
						) : (
							undefined
						)}
					</FancyButton>
				) : (
					undefined
				)}

				{!isPromotionPage && (isLoggedIn || contactVisible) ? (
					<SocialList
						contacts={contacts}
						editable={editable}
						onEdit={editContacts}
						name={firstname}
					/>
				) : !isPromotionPage ? (
					<PrimaryButton onClick={login} icon="comment">
						<span>Login to contact {firstname}</span>
					</PrimaryButton>
				) : null}

				{!isPromotionPage && editable ? (
					<FancyButton className="SocialList-edit" onClick={editContacts}>
						<span className="icon icon-mode_edit" />
						<span>Edit contact details</span>
						{isViewingOwn && subscriptionLevel !== 'none' ? (
							<BioHelper stepKey="contact" />
						) : (
							undefined
						)}
					</FancyButton>
				) : (
					undefined
				)}

				{(avgCommunication || avgQuality || avgTrust || avgAffordability) && (
					<ol className="ProfileSidePane-spark ProfileSidePane-expanded">
						{avgCommunication && (
							<li>
								<label>Comms</label>
								<gutter>
									<value style={{width: avgCommunication + '%'}} />
								</gutter>
								<text>{avgCommunication}%</text>
							</li>
						)}
						{avgQuality && (
							<li>
								<label>Quality</label>
								<gutter>
									<value style={{width: avgQuality + '%'}} />
								</gutter>
								<text>{avgQuality}%</text>
							</li>
						)}
						{avgAffordability && (
							<li>
								<label>Affordability</label>
								<gutter>
									<value style={{width: avgAffordability + '%'}} />
								</gutter>
								<text>{avgAffordability}%</text>
							</li>
						)}
						{avgTrust && (
							<li>
								<label>Trust</label>
								<gutter>
									<value style={{width: avgTrust + '%'}} />
								</gutter>
								<text>{avgTrust}%</text>
							</li>
						)}
					</ol>
				)}

				{communities && (
					<ol className="ProfileSidePane-affiliations">
						{communities.map(community => (
							<li key={community.uuid}>
								<Link to={`/!${community.profile.uniqueName}`}>
									<Avatar
										extraClass="ProfilePageHeader-avatar"
										backgroundImage={community.profile.backgroundImage}
										size={32}
									/>
									<div className="ProfileSidePane-name">{community.name}</div>
								</Link>
							</li>
						))}
					</ol>
				)}
			</section>
		);
	}
}

const ConnectedProfileSidePane = connect(
	state => ({
		favourites: state.session && state.session.favourites,
		profileFirstTime: state.session.profileFirstTime,
		sessionUserIsIdentifiable: sessionUserIsIdentifiable(state)
	}),
	(dispatch, ownProps) => ({
		showCommunityPicker: () => {
			dispatch(
				uiActions.uiPickerCallback(community => {
					dispatch(communityActions.joinCommunity(community.uuid));
					dispatch(uiActions.uiModal(null));
					dispatch(
						uiActions.uiMessage(
							community.type === 'open'
								? `You have joined ${
										community.name
								  }! View the community page for the member list, notices and more`
								: `Your request to join ${community.name} has been sent`
						)
					);
					setTimeout(() => dispatch(actions.retrieveAffiliations()), 100); // BAD Dodgey hack to wait for community request to be sent -- probably a race condition
				})
			);
			dispatch(uiActions.uiModal('community-picker'));
		},
		showInvite: () => {
			dispatch(uiActions.uiModal('invite'));
			dispatch(actions.persistProviderField({user: {openedInvites: true}}));
		},
		setFavourite: () => {
			dispatch(sessionActions.setFavourite(ownProps.profile.uuid, true));
			dispatch(actions.profileAddFavouritedCount());
		},
		setProfileComplete: () =>
			dispatch(
				actions.persistProviderField({
					profile: {
						profileComplete: true
					}
				})
			),
		editDetails: () => {
			dispatch(editingProfileActions.init());
			dispatch(uiActions.uiModal('profile-edit-details'));
		},
		newCommunity: () => {
			dispatch(editingProfileActions.initNewCommunity());
			dispatch(uiActions.uiModal('profile-edit-details'));
		},
		clearFirstTime: () => dispatch(sessionActions.sessionProfileFirstTime(false)),
		copyProfile: uniqueName => dispatch(copyProfileLink(uniqueName))
	})
)(ProfileSidePane);

export default ConnectedProfileSidePane;



// WEBPACK FOOTER //
// ./src/profile/ProfileSidePane.js